module.exports = __webpack_public_path__ + "img/normal_agency_tip.7dd016e0.png";